'use strict';
const stripIndent = require('strip-indent');
const indentString = require('indent-string');

module.exports = (string, count = 0, options) => indentString(stripIndent(string), count, options);
